/* yl-v11.js · Homepage v11 (3 Oct 2026)
   Always:
     1. The vitrine: a piece chosen in the list moves under the light.
        Book pages: the first chapter opens after a few paragraphs (Keep reading).
     The pieces turn: each rotation film loads near the screen, plays silent and loops, with Pause.
   Only with "Scroll effects" on (html.y11-fx, set by the header section; off by default because
   CLAUDE.md invariant 2 rules out scroll-triggered animation):
     2. The page takes the light of the room in view (Screen, Page, Bench).
     3. Room names rise and pictures settle as they arrive (both readable before they move).
     4. The header steps aside on the way down and returns on the way up.
     5. The cinema still drifts a few percent against the scroll.
   Play in place, the menu drawer and the IST clock come from yl-v10.js. */
(function () {
  if (window.__y11) return;
  window.__y11 = true;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var fx = root.classList.contains('y11-fx');

    /* ------------------------------------------------------------ the pieces turn */
    /* Each piece's rotation film loads only when it is near the screen, a phone gets the smaller file,
       only the piece under the light plays, and Pause holds it. Reduced motion starts paused. */
    var turnVids = document.querySelectorAll('video[data-y11-turn]');
    var runTurns = function () {};
    if (turnVids.length) {
      var phone = window.matchMedia('(max-width: 767px)').matches;
      var turnLabel = function (h) {
        var t = h.querySelector('[data-y11-turn-label]');
        if (t) t.textContent = h.classList.contains('is-paused') ? 'Play' : 'Pause';
      };
      var turnRun = function (v) {
        var h = v.closest('[data-y11-turn-host]');
        var a = v.closest('.y11-piece__img');
        var go = v.__near && (!a || a.classList.contains('is-on')) && !(h && h.classList.contains('is-paused'));
        if (go) {
          if (!v.getAttribute('src')) v.src = (phone && v.getAttribute('data-src-small')) || v.getAttribute('data-src');
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      };
      runTurns = function (root) { Array.prototype.forEach.call((root || document).querySelectorAll('video[data-y11-turn]'), turnRun); };
      Array.prototype.forEach.call(document.querySelectorAll('[data-y11-turn-host]'), function (h) {
        if (reduce) h.classList.add('is-paused');
        turnLabel(h);
      });
      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-y11-turn-btn]') : null;
        if (!b) return;
        var h = b.closest('[data-y11-turn-host]');
        if (!h) return;
        h.classList.toggle('is-paused');
        turnLabel(h);
        if (!h.classList.contains('is-paused')) Array.prototype.forEach.call(h.querySelectorAll('video[data-y11-turn]'), function (v) { v.__near = true; });
        runTurns(h);
      });
      if ('IntersectionObserver' in window) {
        var near = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { en.target.__near = en.isIntersecting; turnRun(en.target); });
        }, { rootMargin: '300px 0px' });
        Array.prototype.forEach.call(turnVids, function (v) { near.observe(v); });
      } else {
        Array.prototype.forEach.call(turnVids, function (v) { v.__near = true; turnRun(v); });
      }
    }

    /* ------------------------------------------------------------ 1 · vitrine */
    Array.prototype.forEach.call(document.querySelectorAll('[data-y11-vitrine]'), function (v) {
      var picks = v.querySelectorAll('[data-y11-show]');
      Array.prototype.forEach.call(picks, function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-y11-show');
          Array.prototype.forEach.call(picks, function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          Array.prototype.forEach.call(v.querySelectorAll('.y11-piece__img'), function (a) { a.classList.toggle('is-on', a.getAttribute('data-y11-piece') === i); });
          Array.prototype.forEach.call(v.querySelectorAll('.y11-piece__meta'), function (m) { m.hidden = m.getAttribute('data-y11-piece') !== i; });
          runTurns(v);
        });
      });
    });

    /* ------------------------------------------------------------ book pages: keep reading */
    Array.prototype.forEach.call(document.querySelectorAll('[data-y11-more]'), function (box) {
      var n = parseInt(box.getAttribute('data-y11-more'), 10) || 5;
      var btn = box.parentNode.querySelector('[data-y11-more-btn]');
      var kids = box.children;
      if (!btn || kids.length <= n + 1) return;
      var rest = Array.prototype.slice.call(kids, n);
      rest.forEach(function (k) { k.hidden = true; });
      btn.hidden = false;
      btn.addEventListener('click', function () {
        rest.forEach(function (k) { k.hidden = false; });
        btn.setAttribute('aria-expanded', 'true');
        btn.hidden = true;
        var first = rest[0];
        first.setAttribute('tabindex', '-1');
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
      });
    });

    if (!fx) return;

    /* ------------------------------------------------------------ 2 · the light of the room in view */
    var rooms = document.querySelectorAll('.y11[data-y11-light]');
    var navLinks = document.querySelectorAll('[data-y11-room]');
    var setLight = function (light, id) {
      root.classList.toggle('y11-light-page', light === 'page');
      root.classList.toggle('y11-light-bench', light === 'bench');
      Array.prototype.forEach.call(navLinks, function (a) { a.classList.toggle('is-here', !!id && a.getAttribute('data-y11-room') === id); });
    };
    if ('IntersectionObserver' in window) {
      var centre = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setLight(e.target.getAttribute('data-y11-light'), e.target.id); });
      }, { rootMargin: '-66% 0px -34% 0px' });
      Array.prototype.forEach.call(rooms, function (r) { centre.observe(r); });

      /* ---------------------------------------------------------- 3 · arrivals */
      var arrive = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); arrive.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px' });
      Array.prototype.forEach.call(document.querySelectorAll('.y11-rise, .y11-settle'), function (n) {
        if (reduce) n.classList.add('is-in'); else arrive.observe(n);
      });
    }

    /* ------------------------------------------------------------ 4 · header, 5 · cinema drift */
    var top = document.querySelector('.y11-top');
    var drawer = document.getElementById('y10-drawer');
    var cinemaImg = document.querySelector('.y11-cinema .y11-play img');
    var cinema = cinemaImg ? cinemaImg.closest('.y11-cinema') : null;
    var lastY = window.scrollY, ticking = false;
    var onScroll = function () {
      var yy = window.scrollY;
      if (top) {
        top.classList.toggle('is-solid', yy > 40);
        var open = drawer && !drawer.hidden;
        if (!open && yy > 400 && yy > lastY + 2) top.classList.add('is-hidden');
        else if (yy < lastY - 2 || yy <= 400 || open) top.classList.remove('is-hidden');
      }
      lastY = yy;
      if (cinema && !reduce && !cinema.classList.contains('is-playing')) {
        var r = cinema.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom > 0 && r.top < vh) {
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          cinemaImg.style.transform = 'translate3d(0,' + (p * -7).toFixed(2) + '%,0)';
        }
      }
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  });
})();
